import { Catalog } from "../../../types";
import { clientesConfig } from "../../../utils/config";

// Fetch the canonical RBAC catalog directly from clientes-backend's PUBLIC /catalog.
// The catalog is public (no auth) and clientes-backend is not reachable from the gestor
// VPC, so this is a direct browser call rather than a gestor-backend proxy hop.
export const getCatalog = async (): Promise<Catalog> => {
  const base = clientesConfig.clientesApi.replace(/\/+$/, "");
  const response = await fetch(`${base}/catalog`);
  if (!response.ok) {
    throw new Error(`Failed to load catalog: ${response.status}`);
  }
  return response.json();
};
